(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('RootCauseAnalysisFactorDetailController', RootCauseAnalysisFactorDetailController);

    RootCauseAnalysisFactorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RootCauseAnalysisFactor', 'Company'];

    function RootCauseAnalysisFactorDetailController($scope, $rootScope, $stateParams, previousState, entity, RootCauseAnalysisFactor, Company) {
        var vm = this;

        vm.rootCauseAnalysisFactor = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:rootCauseAnalysisFactorUpdate', function(event, result) {
            vm.rootCauseAnalysisFactor = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
